module.exports = __webpack_public_path__ + "img/chat-left-quote.dfd1ee07.svg";